import { useCallback, useEffect, useRef } from "react";

const useFormProgress = handleVisibility => {
  const observerRef = useRef(null);
  const elementsRef = useRef(new Set());

  const observeElements = useCallback(() => {
    const elements = document.querySelectorAll("[data-step-title]");
    elements.forEach(element => {
      if (!elementsRef.current.has(element)) {
        elementsRef.current.add(element);
        observerRef.current.observe(element);
      }
    });
  }, []);

  const handleIntersection = useCallback(
    entries => {
      entries.forEach(entry => {
        const stepTitle = entry.target.getAttribute("data-step-title");
        if (entry.isIntersecting) {
          if (handleVisibility) handleVisibility(stepTitle);
        }
      });
    },
    [handleVisibility],
  );

  useEffect(() => {
    if (!observerRef.current) {
      observerRef.current = new IntersectionObserver(handleIntersection, {
        root: null,
        rootMargin: "0px",
        threshold: 1,
      });
    }

    observeElements();

    const mutationObserver = new MutationObserver(() => {
      observeElements();
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      if (observerRef.current) {
        elementsRef.current.forEach(element => observerRef.current.unobserve(element));
        observerRef.current.disconnect();
      }
      mutationObserver.disconnect();
    };
  }, [handleIntersection, observeElements]);

  return;
};

export default useFormProgress;
